(function () {
  'use strict';

  angular
    .module('app')
    .component('bookingItemServiceItemsCostBased', bookingItemServiceItemsCostBased());

  function bookingItemServiceItemsCostBased() {
    return {
      bindings: {
        bookingItem: '=',
        booking: '<',
        documentDateExchangeRate: '<',
        onBookingItemServiceItemsCostBasedSaved: '&',
      },
      controller: BookingItemServiceItemsCostBasedCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/components/' +
        'booking-item-service-items-cost-based/booking-item-service-items-cost-based.component.html',
    };
  }

  BookingItemServiceItemsCostBasedCtrl.$inject = [
    'UtilService',
    'AvailabilityService',
    'ModalWindowConfirmService',
    'moment',
    'TourService',
    'TransportationService',
    'BookingItemServiceItemService',
    'TaxService',
    'ExchangeRateService',
  ];

  function BookingItemServiceItemsCostBasedCtrl(
    UtilService,
    AvailabilityService,
    ModalWindowConfirmService,
    moment,
    TourService,
    TransportationService,
    BookingItemServiceItemService,
    TaxService,
    ExchangeRateService
  ) {
    let vm = this;

    vm.UtilService = new UtilService(vm);

    vm.paxPopover = {
      templateUrl: 'template_pax.html',
      open: function open(bookingItemServiceItemSelected) {
        vm.bookingItemServiceItemCopy = angular.copy(bookingItemServiceItemSelected);

        bookingItemServiceItemSelected.paxPopoverIsOpen = true;
        vm.bookingItemServiceItemSelected = bookingItemServiceItemSelected;
      },
      close: function close() {
        // bookingItemServiceItemSelected
        vm.bookingItemServiceItemSelected.paxPopoverIsOpen = false;
        vm.bookingItemServiceItemSelected = null;
      },
      save: function save(bookingItemServiceItemObj) {
        vm.bookingItemServiceItemSelected.paxPopoverIsOpen = false;

        vm.bookingItemServiceItemSelected.quantity =
          setBookingItemServiceItemQuantity(bookingItemServiceItemObj);
        vm.bookingItemServiceItemSelected.adults = bookingItemServiceItemObj.adults;
        vm.bookingItemServiceItemSelected.children = bookingItemServiceItemObj.children;
        vm.bookingItemServiceItemSelected.infants = bookingItemServiceItemObj.infants;
        vm.bookingItemServiceItemSelected.seniors = bookingItemServiceItemObj.seniors;

        updatePaxCosts(vm.bookingItemServiceItemSelected);
        // vm.bookingItemServiceItemCopy = null;
      },
    };

    // Methods
    vm.updateBookingItemServiceItemCosts = updateBookingItemServiceItemCosts;
    vm.openBookingItemServiceItemStandardCostBased = openBookingItemServiceItemStandardCostBased;

    vm.onBookingItemServiceItemPaxSaved = onBookingItemServiceItemPaxSaved;
    vm.onBookingItemServiceItemPaxCanceled = onBookingItemServiceItemPaxCanceled;

    vm.saveBookingItemServiceItemsCostBased = saveBookingItemServiceItemsCostBased;

    vm.$onInit = function () {
      vm.loadingAvailability = true;

      vm.currencySymbol = vm.booking.currency.symbol;
      vm.decimalPlaces = vm.booking.currency.decimal_places;

      vm.bookingItemNetPrice = vm.bookingItem.net_price;
      vm.bookingItemNetCost = vm.bookingItem.net_cost;
      vm.bookingItemNetProfit = vm.bookingItem.net_price - vm.bookingItem.net_cost;

      switch (vm.bookingItem.booking_type) {
        case 'tour':
          getTour();
          break;
        case 'transportation':
          getTransportation();
          break;
        case 'hotel':
          // console.log('getHotels');
          break;
      }

      // getProvidersCostAndPrices();
    };

    function getTour() {
      let params = {
        costs: false,
        taxes: true,
        skip_check_role: true,
      };

      TourService.getTour(vm.bookingItem.tour_id, params).then(function (data) {
        vm.product = data;

        getProvidersCostAndPrices();
      });
    }

    function getTransportation() {
      let params = {
        costs: false,
        taxes: true,
        skip_check_role: true,
      };

      TransportationService.getTransportation(vm.bookingItem.transportation_id, params).then(
        function (data) {
          vm.product = data;

          getProvidersCostAndPrices();
        }
      );
    }

    function onBookingItemServiceItemPaxSaved(bookingItemServiceItemObj) {
      vm.paxPopover.save(bookingItemServiceItemObj);
    }

    function onBookingItemServiceItemPaxCanceled() {
      // selectedItem
      vm.paxPopover.close(); // selectedItem
    }

    // Check product availability for a provider
    function getProvidersCostAndPrices() {
      let params = {
        product_type: vm.bookingItem.booking_type,
        start_date: vm.bookingItem.start_date,
        end_date: vm.bookingItem.end_date,
        adults: vm.bookingItem.adults,
        children: vm.bookingItem.children,
        infants: vm.bookingItem.infants,
        seniors: vm.bookingItem.seniors,
        price_list_id: vm.bookingItem.price_list_id,
        booking_price_list_id: vm.booking.price_list_id,
        client_id: vm.booking.client_id,
        company_id: vm.booking.company_id,
        service_items: true,
        skip_check_role: true,

        tour_id: null,
        tour_option_id: null,
        tour_option_schedule_id: null,
        transportation_id: null,
        transportation_schedule_id: null,
      };

      switch (vm.bookingItem.booking_type) {
        case 'tour':
          params.tour_id = vm.bookingItem.tour_id;
          params.tour_option_id = vm.bookingItem.tour_option_id;
          params.tour_option_schedule_id = vm.bookingItem.tour_option_schedule_id;

          vm.productCostType = 'per_person';
          break;
        case 'transportation':
          params.transportation_id = vm.bookingItem.transportation_id;
          params.transportation_schedule_id = vm.bookingItem.transportation_schedule_id;

          vm.productCostType =
            vm.bookingItem.detail.schedule_type === 'open' ? 'per_service' : 'per_person';
          break;
        // TODO hotels ?
      }

      let applyExchangeRateConversion = (amount) =>
        ExchangeRateService.applyExchangeRateConversion(amount, vm.documentDateExchangeRate);

      AvailabilityService.getProvidersCostAndPrices(params).then(function (data) {
        // TODO: What about current prices and commission ? we need to call it from the api
        vm.clientCommissionPercentage = vm.bookingItem.commission_price_percentage;

        if (vm.productCostType === 'per_person') {
          vm.bookingItemAdultsPrice =
            vm.bookingItem.adults *
            (vm.bookingItem.adult_price -
              (vm.bookingItem.adult_price * vm.clientCommissionPercentage) / 100);

          vm.bookingItemChildrenPrice =
            vm.bookingItem.children *
            (vm.bookingItem.child_price -
              (vm.bookingItem.child_price * vm.clientCommissionPercentage) / 100);

          vm.bookingItemInfantsPrice =
            vm.bookingItem.infants *
            (vm.bookingItem.infant_price -
              (vm.bookingItem.infant_price * vm.clientCommissionPercentage) / 100);

          vm.bookingItemSeniorsPrice =
            vm.bookingItem.seniors *
            (vm.bookingItem.senior_price -
              (vm.bookingItem.senior_price * vm.clientCommissionPercentage) / 100);
        } else {
          vm.bookingItemServicePrice =
            vm.bookingItem.seniors *
            (vm.bookingItem.item_price -
              (vm.bookingItem.item_price * vm.clientCommissionPercentage) / 100);
        }

        data.item_costs.forEach(function (serviceItemsCost) {
          for (let i = 0; i < vm.bookingItem.booking_item_service_items.length; i++) {
            let bookingItemServiceItem = vm.bookingItem.booking_item_service_items[i];

            if (bookingItemServiceItem.service_item_id !== serviceItemsCost.service_item_id) {
              continue; // It works as the contrary of break
            }

            bookingItemServiceItem.providerCosts = serviceItemsCost.providers_cost; // !important

            serviceItemsCost.providers_cost.forEach(function (providerCost) {
              // Provider has costs for
              if (
                providerCost.costs &&
                bookingItemServiceItem.provider_id === providerCost.provider_id
              ) {
                bookingItemServiceItem.has_costs = true;

                if (bookingItemServiceItem.service_item.cost_type === 'per_person') {
                  bookingItemServiceItem.adult_cost = applyExchangeRateConversion(
                    providerCost.costs.adult_cost
                  );

                  bookingItemServiceItem.adults_cost =
                    bookingItemServiceItem.adults * bookingItemServiceItem.adult_cost;
                  // bookingItemServiceItem.adults_profit   = vm.bookingItemAdultsPrice - bookingItemServiceItem.adults_cost;

                  bookingItemServiceItem.child_cost = applyExchangeRateConversion(
                    providerCost.costs.child_cost
                  );

                  bookingItemServiceItem.children_cost =
                    bookingItemServiceItem.children * bookingItemServiceItem.child_cost;
                  // bookingItemServiceItem.children_profit = vm.bookingItemChildrenPrice - bookingItemServiceItem.children_cost;

                  bookingItemServiceItem.infant_cost = applyExchangeRateConversion(
                    providerCost.costs.infant_cost
                  );

                  bookingItemServiceItem.infants_cost =
                    bookingItemServiceItem.infants * bookingItemServiceItem.infant_cost;
                  // bookingItemServiceItem.infants_profit  = vm.bookingItemInfantsPrice - bookingItemServiceItem.infants_cost;

                  bookingItemServiceItem.senior_cost = applyExchangeRateConversion(
                    providerCost.costs.senior_cost
                  );

                  bookingItemServiceItem.seniors_cost =
                    bookingItemServiceItem.seniors * bookingItemServiceItem.senior_cost;
                  // bookingItemServiceItem.seniors_profit  = vm.bookingItemSeniorsPrice - bookingItemServiceItem.seniors_cost;

                  bookingItemServiceItem.item_cost =
                    bookingItemServiceItem.adults_cost +
                    bookingItemServiceItem.children_cost +
                    bookingItemServiceItem.infants_cost +
                    bookingItemServiceItem.seniors_cost;
                } else {
                  bookingItemServiceItem.item_cost = applyExchangeRateConversion(
                    providerCost.costs.service_cost
                  );
                }

                // bookingItemServiceItem.providerCosts = providerCost.costs;
              }
            });
          }
        });

        // console.log(vm.bookingItem.booking_item_service_items);

        vm.loadingAvailability = false;
      });
    }

    function updateBookingItemServiceItemCosts() {
      let bookingItemItemCost = 0,
        bookingItemBaseCost = 0,
        bookingItemNetCost = 0,
        bookingItemSubtotalCost = 0,
        bookingItemTaxCost = 0;

      vm.bookingItem.booking_item_service_items.forEach(function (bookingItemServiceItem) {
        if (bookingItemServiceItem.included) {
          bookingItemItemCost += bookingItemServiceItem.item_cost;
          bookingItemBaseCost += bookingItemServiceItem.base_cost;
          bookingItemNetCost += bookingItemServiceItem.net_cost;
          bookingItemSubtotalCost += bookingItemServiceItem.subtotal_cost;
          bookingItemTaxCost += bookingItemServiceItem.tax_cost;
        }
      });

      vm.bookingItem.item_cost = bookingItemItemCost;
      vm.bookingItem.base_cost = bookingItemBaseCost;
      vm.bookingItem.net_cost = bookingItemNetCost;
      vm.bookingItem.subtotal_cost =
        bookingItemSubtotalCost + vm.bookingItem.pickup_cost + vm.bookingItem.dropoff_cost;
      vm.bookingItem.tax_cost = bookingItemTaxCost;
      vm.bookingItem.total_cost = vm.bookingItem.subtotal_cost + bookingItemTaxCost;

      vm.bookingItemNetCost = vm.bookingItem.net_cost; //  - vm.bookingItem.discount_cost
      vm.bookingItemNetProfit = vm.bookingItemNetPrice - vm.bookingItemNetCost;

      // console.log('updateBookingItemServiceItemCosts');
      // console.log(vm.bookingItem.booking_item_service_items);
    }

    function openBookingItemServiceItemStandardCostBased(bookingItemServiceItem) {
      let successCallback = (bookingItemServiceItemObj) => updateBookingItemServiceItemCosts();

      BookingItemServiceItemService.openBookingItemServiceItemStandardCostBased(
        bookingItemServiceItem,
        vm.bookingItem,
        vm.booking,
        vm.documentDateExchangeRate,
        successCallback
      ); // , vm.taxes
    }

    // TODO: What about pax ranges?
    function updatePaxCosts(bookingItemServiceItem) {
      let bookingItemServiceItemItemCost = 0;
      if (bookingItemServiceItem.service_item.cost_type === 'per_person') {
        let adultsCost = bookingItemServiceItem.adults * bookingItemServiceItem.adult_cost;
        let childrenCost = bookingItemServiceItem.children * bookingItemServiceItem.child_cost;
        let infantsCost = bookingItemServiceItem.infants * bookingItemServiceItem.infant_cost;
        let seniorsCost = bookingItemServiceItem.seniors * bookingItemServiceItem.senior_cost;

        bookingItemServiceItemItemCost = adultsCost + childrenCost + infantsCost + seniorsCost;
      } else {
        bookingItemServiceItemItemCost = bookingItemServiceItem.item_cost;
      }

      // Product taxes based on document date
      // let documentDate = moment(vm.booking.created_at);
      // let purchaseTaxes = TaxService.setProductTaxes(vm.product, documentDate).purchaseTaxes;

      // Product taxes based on service date
      let serviceDate = moment(vm.bookingItem.start_date);
      let productPurchaseTaxes = TaxService.setProductTaxes(vm.product, serviceDate).purchaseTaxes;

      let item_cost = bookingItemServiceItemItemCost;
      let base_cost = TaxService.setBaseCostPrice(
        bookingItemServiceItem.item_cost,
        bookingItemServiceItem.price_list,
        productPurchaseTaxes
      );
      let net_cost = base_cost;
      let pickup_cost = 0;
      let dropoff_cost = 0;
      let discount_cost = 0;
      let subtotal_cost = net_cost + pickup_cost + dropoff_cost - discount_cost;
      let tax_cost_percentage = TaxService.getProductTaxesTotalPercentage(productPurchaseTaxes);

      bookingItemServiceItem.purchase_taxes = TaxService.setProductTaxesAmounts(
        subtotal_cost,
        productPurchaseTaxes
      );

      let tax_cost = TaxService.getProductTaxesTotalAmount(bookingItemServiceItem.purchase_taxes);
      let total_cost = subtotal_cost + tax_cost;

      bookingItemServiceItem.item_cost = vm.UtilService.roundNum(item_cost);
      bookingItemServiceItem.base_cost = vm.UtilService.roundNum(base_cost);
      bookingItemServiceItem.net_cost = vm.UtilService.roundNum(net_cost);
      bookingItemServiceItem.discount_cost = vm.UtilService.roundNum(discount_cost); // conversion needed *
      bookingItemServiceItem.subtotal_cost = vm.UtilService.roundNum(subtotal_cost);
      bookingItemServiceItem.tax_cost_percentage = tax_cost_percentage;
      bookingItemServiceItem.tax_cost = vm.UtilService.roundNum(tax_cost);
      bookingItemServiceItem.total_cost = vm.UtilService.roundNum(total_cost);

      // console.log(bookingItemServiceItem);

      updateBookingItemServiceItemCosts();
    }

    function setBookingItemServiceItemQuantity(bookingItemServiceItem) {
      if (bookingItemServiceItem.service_item.cost_type === 'per_service') {
        return 1;
      }

      return (
        bookingItemServiceItem.adults +
        bookingItemServiceItem.children +
        bookingItemServiceItem.infants +
        bookingItemServiceItem.seniors
      );
    }

    function saveBookingItemServiceItemsCostBased() {
      let confirmCallback = () => {
        vm.onBookingItemServiceItemsCostBasedSaved({ bookingItem: vm.bookingItem });
      };

      let params = {
        title: 'CHANGE_PROVIDER',
        body: 'CHANGING_PROVIDER_FOR_BOOKING_WARNING',
        mode: 'danger',
        requireConfirmation: true,
      };

      ModalWindowConfirmService.open(params, confirmCallback);
    }
  }
})();
